/**
 * Initialize all Tippy tooltips used throughout the iSchedule application.
 * 
 * @param {jQuery} $ - jQuery instance (required for changeZipTippy functionality)
 * @returns {Object} Object containing tooltip instances (currently changeZipTippy)
 */
export function initTooltips($) {
	// Initialize virtual description tooltip
	tippy(".tippy-virtual-desc", {
		content: document.getElementById("isched_virtual_desc_content")?.innerHTML || "",
		allowHTML: true,
		theme: "ischedule",
	});

	// Initialize in-center description tooltip
	tippy(".tippy-in-center-desc", {
		content: document.getElementById("isched_incenter_desc_content")?.innerHTML || "",
		allowHTML: true,
		theme: "ischedule",
	});

	// Initialize live description tooltip
	tippy(".tippy-live-desc", {
		content: document.getElementById("isched_live_desc_content")?.innerHTML || "",
		allowHTML: true,
		theme: "ischedule",
	});

	// Initialize LASIK cash description tooltip
	tippy(".tippy-lasik-cash-desc", {
		content: document.getElementById("isched_lasik_cash_desc_content")?.innerHTML || "",
		allowHTML: true,
		theme: "ischedule",
	});

	// Initialize change zip code tooltip (only used on schedule page)
	let changeZipTippy;
	const changeZipElement = document.querySelector(".isched_change_zip_code");
	if (changeZipElement && $) {
		changeZipTippy = tippy(".isched_change_zip_code", {
			content: document.getElementById("isched_change_zip_code_content")?.innerHTML || "",
			allowHTML: true,
			theme: "zip",
			trigger: 'click',
			interactive: true,
			onShow(instance) {
				// Wrap in jQuery to use jQuery methods
				const $tippyZipForm = $(instance.popper.querySelector('form'));
				const $tippyZipInput = $tippyZipForm.find('input[name="zip"]');

				// Clear existing errors
				$tippyZipForm.parsley().reset();

				// Focus the zip input when the tooltip is shown
				setTimeout(() => {
					if ($tippyZipInput.length) {
						$tippyZipInput.focus();
					}
				}, 100);
			}
		});
	}

	return {
		changeZipTippy
	};
}
